/**
 * Created by Jerker Nord on 2020-04-03.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../BonusBunniesGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BonusBunniesParsedInitData} from "../server/data/BonusBunniesParsedInitData";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";

export class BonusBunniesBonusGameInfoPlate extends BaseView {

    private _infoContainer:PIXI.Container;
    private _4RowYPosition:number = 668;
    private _4RowXPosition:number = 367;
    private _5RowYPosition:number = 820;
    private _extraReelXPosition:number = 445;
    private _extraReelScaleX:number = 1.248;
    private _infoPlate:PIXI.Sprite;
    private _infoText:PIXI.Text;
    private _infoTextString:string = "Fill all positions to get the key to the chest!";
    private _infoTextStyle:PIXI.TextStyle = new PIXI.TextStyle({
        fill : 0x80ff22,
        fontFamily : "Open Sans",
        fontWeight : "bold",
        wordWrap : false,
        padding : 20,
        fontSize : 14,
        breakWords : false,
        stroke : "#000000",
        strokeThickness : 2
    });

    constructor() {
        super();
        this._infoContainer = new PIXI.Container();
        this._infoContainer.visible = false;
        this.addChild(this._infoContainer);
        StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.BASE_FEATURE.name).addChild(this);
        this.addFeatureEventHandlers();
    }

    private addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        //EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.parseFeatureGameData(event.params[0]));
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        if(data.isRestoreState == true && data.mode == BonusBunniesGameMode.BONUS_GAME) {
            this.set4RowPosition();
            if (data.bottomRowActivated == true){
                this.set5RowPosition();
            }
            if (data.lastReelActivated == true){
                this.setExtraReelPositionAndScale();
            }
            this.enableInfo();
        }
    }

    protected initAnimations():void {
        this._infoPlate = new PIXI.Sprite(GameResources.getTextures("text_board")[0]);
        this._infoPlate.anchor.set(0.5, 0.5);
        this._infoContainer.addChild(this._infoPlate);

        this._infoText = new PIXI.Text(SlotGame.api.translations.translate(this._infoTextString), this._infoTextStyle);
        this._infoText.anchor.set(0.5, 0.5);
        this._infoText.position.y = -1;
        this._infoContainer.addChild(this._infoText);
    }

    public set4RowPosition():void{
        this._infoContainer.position.y = this._4RowYPosition;
        this._infoContainer.position.x = this._4RowXPosition;
        this._infoContainer.scale.x = 1;
    }

    public set5RowPosition():void{
        this._infoContainer.position.y = this._5RowYPosition;
        this._infoContainer.scale.x = 1;
    }

    public setExtraReelPositionAndScale():void{
        this._infoContainer.position.x = this._extraReelXPosition;
        this._infoContainer.scale.x = this._extraReelScaleX;
    }

    public disableInfo():void{
        this._infoContainer.visible = false;
    }

    public enableInfo():void{
        this._infoContainer.visible = true;
    }
}
